export const isUnauthorized = error => error.response && error.response.statusCode === 401
export const logException = exception => {
  if (!isUnauthorized(exception)) {
    console.error(exception) // eslint-disable-line
  }
}
